import { supabase } from "./supabaseClient";
export async function feedbackStaffRequest(body?: object) {
  const { data } = await supabase.auth.getSession();
  if (!data.session) throw new Error("Veuillez vous reconnecter.");
  const response = await fetch("/api/feedback/staff", {
    method: body ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${data.session.access_token}`,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "Impossible de charger les avis.");
  return result;
}
